/**
 * Vue router navigation guards with Vuex
 * Blocking off certain features of the application if the user is not authenticated
 */
/* e3slint-disable */
import store from '@/store/index';

export function checkLoginStatus(to, from, next) {
  let isLoggedIn = store.getters['login/isLoggedIn'];
  console.log(isLoggedIn)
  if (isLoggedIn && to.query.dest === 'notes'){
    console.log('HAAAAAA', to, from)
    next('/notes')
    return
  }
  if (to.path === '/welcome' && from.path === '/login' && from.query.dest == 'notes'){
    next('/notes')
    return
  }
  if (to.path === '/login') {
    console.log('HERE1', to, from)
    if (isLoggedIn) 
      next('/welcome');
    else next();
  }
  else if (to.fullPath === '/null' && isLoggedIn){
    next('/welcome')
  }
  else if (to.path === '/register' 
  || to.path === '/forgot' 
  || to.path === '/reset'
  || to.path === '/verify'
  || to.name === 'VerifyNurseNavigation'
  ) {
    if (isLoggedIn)
      next('/welcome');
    else next();
    return;
  }
  else if (isLoggedIn) {
    console.log('HERE2', to, from)
    next();
  } else {
    console.log('HERE3', to, from)
    next('/login');
  }
}
